import { render } from "./Bancos.vue?vue&type=template&id=043fe078"
import script from "./Bancos.vue?vue&type=script&lang=js"
export * from "./Bancos.vue?vue&type=script&lang=js"
script.render = render

export default script